import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { m } from "@vega-core/paraglide/messages";

type CasVisibilityConfirmationModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isVisible: boolean;
  fundName: string;
  fundId?: string;
  templateKey?: string;
  isLoading?: boolean;
};

export const CasVisibilityConfirmationModal = ({
  open,
  onOpenChange,
  onConfirm,
  isVisible,
  fundName,
  isLoading = false,
}: CasVisibilityConfirmationModalProps) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  const getDescription = () => {
    if (isVisible) {
      return m.cas_confirmation_turn_on({ fundName });
    }

    return m.cas_confirmation_turn_off({ fundName });
  };

  return (
    <ActionaryModal
      ModalButtonsGroupProps={{
        mainAction: handleConfirm,
        mainActionText: m.common_complete(),
        secondaryAction: handleCancel,
        secondaryActionText: m.common_cancel(),
        disabled: isLoading,
      }}
      dataTestId="cas-confirmation-modal"
      fluidHeight
      open={open}
      setOpen={onOpenChange}
      title={m.cas_confirmation_title()}
    >
      <p className="text-text/secondary mb-4 text-left">{getDescription()}</p>
    </ActionaryModal>
  );
};
